import { Badge } from '../ui/badge';
import { Building2, MapPin, Star, Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

const statusConfig = {
  new: { label: 'New', class: 'status-new' },
  contacted: { label: 'Contacted', class: 'status-contacted' },
  qualified: { label: 'Qualified', class: 'status-qualified' },
  proposal: { label: 'Proposal', class: 'status-proposal' },
  won: { label: 'Won', class: 'status-won' },
  lost: { label: 'Lost', class: 'status-lost' },
};

export const LeadCard = ({ lead, isSelected, onClick }) => {
  const status = statusConfig[lead.status] || statusConfig.new;
  
  const getLastUpdated = () => {
    try {
      const date = new Date(lead.updated_at);
      return formatDistanceToNow(date, { addSuffix: true });
    } catch {
      return 'recently';
    }
  };

  return (
    <div
      onClick={onClick}
      className={`
        p-4 cursor-pointer lead-card-hover group relative
        ${isSelected ? 'bg-muted/50 border-l-[3px] border-l-accent' : 'border-l-[3px] border-l-transparent'}
      `}
      data-testid={`lead-card-${lead.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <Building2 className="w-4 h-4 text-muted-foreground flex-shrink-0" />
            <h3 className="font-semibold text-sm truncate">{lead.business_name}</h3>
          </div>
          
          {lead.address && (
            <div className="flex items-center gap-1.5 text-xs text-muted-foreground mb-2">
              <MapPin className="w-3 h-3 flex-shrink-0" />
              <span className="truncate">{lead.address}</span>
            </div>
          )}

          <div className="flex items-center gap-3 text-xs">
            {lead.rating && (
              <div className="flex items-center gap-1">
                <Star className="w-3 h-3 text-amber-500 fill-amber-500" />
                <span>{lead.rating}</span>
                {lead.review_count && (
                  <span className="text-muted-foreground">({lead.review_count})</span>
                )}
              </div>
            )}
            
            <div className="flex items-center gap-1 text-muted-foreground">
              <Clock className="w-3 h-3" />
              <span className="mono-text">{getLastUpdated()}</span>
            </div>
          </div>
        </div>

        <Badge className={`${status.class} text-xs font-medium`} variant="secondary">
          {status.label}
        </Badge>
      </div>
    </div>
  );
};
